export default __webpack_public_path__ + "static/media/soehne-web-leicht.2213b9ef.woff2";